var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "append-to-body": "",
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "el-form",
        { staticStyle: { "margin-left": "10px", "margin-right": "10px" } },
        [
          _c("div", { staticClass: "systemTitle" }, [_vm._v("老系统：")]),
          _c(
            "el-form-item",
            {
              staticStyle: { "margin-bottom": "40px" },
              attrs: { label: "线路名称", "label-width": _vm.formLabelWidth },
            },
            [
              _vm._l(_vm.lineList, function (el, i) {
                return _c(
                  "el-select",
                  {
                    key: i + "_idx",
                    staticStyle: { margin: "0 10px 10px 0" },
                    attrs: { filterable: "", placeholder: "请选择" },
                    model: {
                      value: el.lineId,
                      callback: function ($$v) {
                        _vm.$set(el, "lineId", $$v)
                      },
                      expression: "el.lineId",
                    },
                  },
                  _vm._l(_vm.oldLine, function (item) {
                    return _c("el-option", {
                      key: item.lineId,
                      attrs: { label: item.lineName, value: item.lineId },
                    })
                  }),
                  1
                )
              }),
              _c(
                "el-button",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    "margin-right": "10px",
                  },
                  attrs: { type: "text", size: "medium" },
                  on: { click: _vm.addOldLineClick },
                },
                [_vm._v("新增\n            ")]
              ),
            ],
            2
          ),
          _c("div", { staticClass: "systemTitle" }, [_vm._v("新系统：")]),
          _c(
            "el-form-item",
            {
              attrs: { label: "出发目的地", "label-width": _vm.formLabelWidth },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "请选择" },
                  on: {
                    change: function ($event) {
                      return _vm.areaChange($event, "start")
                    },
                  },
                  model: {
                    value: _vm.form.startAreaId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "startAreaId", $$v)
                    },
                    expression: "form.startAreaId",
                  },
                },
                _vm._l(_vm.areaList, function (item) {
                  return _c("el-option", {
                    key: item.areaManageId,
                    attrs: { label: item.areaName, value: item.areaManageId },
                  })
                }),
                1
              ),
              _c("span", [_vm._v("-")]),
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "请选择" },
                  on: {
                    change: function ($event) {
                      return _vm.areaChange($event, "end")
                    },
                  },
                  model: {
                    value: _vm.form.endAreaId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "endAreaId", $$v)
                    },
                    expression: "form.endAreaId",
                  },
                },
                _vm._l(_vm.areaList, function (item) {
                  return _c("el-option", {
                    key: item.areaManageId,
                    attrs: { label: item.areaName, value: item.areaManageId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "跳转日期", "label-width": _vm.formLabelWidth } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: { type: "date", placeholder: "选择日期" },
                model: {
                  value: _vm.form.jumpTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "jumpTime", $$v)
                  },
                  expression: "form.jumpTime",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeLineEdit } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveLineConfig } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }